import { DocumentVersion } from './document-version';

export class Document {
  public entity?: string;
  public entityId?: string;
  public creatorId?: string;
  public modifierId?: string;
  public created: string; // ($date - time)
  public updated?: string; // ($date - time)
  public clientId?: string;
  public lastVersionId?: string;
  public lastVersion?: DocumentVersion;
  public id?: string;
  public reference?: string;

  public description?: string;
  public version?: number;

  constructor(data?: Partial<Document>) {
    Object.assign(this, data);
  }
}
